// extracted by mini-css-extract-plugin
export default {"siderbarItems":"SidebarItems_siderbarItems__Jyj2e","active":"SidebarItems_active__EmSY0"};